import{defineMessages}from"react-intl";export const messages=defineMessages({actionsLabel:{id:"jutro-quick-view.actionsLabel",defaultMessage:"Actions"}});